var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvaliation0(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 14C25.4392 14 14 25.4392 14 39.5C14 53.5607 25.4392 65 39.5 65C53.5607 65 65 53.5607 65 39.5C65 25.4392 53.5607 14 39.5 14Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3332 34.4444C33.3332 36.2853 31.8389 37.7778 29.9998 37.7778C28.1606 37.7778 26.6665 36.2852 26.6665 34.4444C26.6665 32.6053 28.1606 31.1111 29.9998 31.1111C31.8389 31.1111 33.3332 32.6053 33.3332 34.4444Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3332 34.4444C53.3332 36.2853 51.8391 37.7778 49.9998 37.7778C48.1606 37.7778 46.6665 36.2852 46.6665 34.4444C46.6665 32.6053 48.1606 31.1111 49.9998 31.1111C51.8391 31.1111 53.3332 32.6053 53.3332 34.4444Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1111 51.1111C32.8672 48.2694 36.5603 46.5168 40.4679 46.6624C44.0554 46.7962 47.2913 48.5106 48.8889 51.1111",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaliation0);
export default __webpack_public_path__ + "static/media/avaliation-0.275ceb5fa20e451bbabf92db2ba0018c.svg";
export { ForwardRef as ReactComponent };